import ApplicationSerializer from 'eflex/serializers/application';

export default class GroupSerializer extends ApplicationSerializer {
  attrs = {
    stations: {
      deserialize: false,
      serialize: false,
    },
  };
}
